import { ReactNode } from 'react'

import { Image } from '@/shared/ui/Image'

import cls from './HeroBanner.module.scss'

export type HeroTextBannerProps = {
	title: string
	subtitle?: string | ReactNode
	imgSrc: string
	minTitle?: boolean
}

export const HeroBanner = ({ title, subtitle, imgSrc, minTitle }: HeroTextBannerProps): JSX.Element => (
	<div className={cls.HeroTextBanner}>
		<div className={cls.HeroTextWrapper}>
			<div className={cls.HeroTextBanner__InfoContent}>
				<h2
					className={
						minTitle ? `${cls.HeroTextBanner__Title} ${cls.HeroTextBanner__Title_min}` : cls.HeroTextBanner__Title
					}>
					{title}
				</h2>
				{subtitle != null && <div className={cls.HeroTextBanner__SubTitle}>{subtitle}</div>}
			</div>
		</div>
		{imgSrc && (
			<div className={cls.HeroTextBanner__Image}>
				<Image alt={title} src={imgSrc} width={378} height={276} priority />
			</div>
		)}
	</div>
)
